module.exports = {

  /**
   * @param _$el {HTMLElement}
   */
  remove: (_$el) => {
    _$el.parentNode.removeChild(_$el);
  },

  /**
   * @param _$el {HTMLElement}
   */
  empty: (_$el) => {
    while(_$el.firstChild) _$el.removeChild(_$el.firstChild);
  },

  /**
   * @param _$el {HTMLElement}
   * @param _fn {function} function to execute between
   */
  displayMoment: (_$el, _fn) => {
    _$el.style.display = 'block';
    _fn();
    _$el.style.display = 'none';
  },

}



/** WEBPACK FOOTER **
 ** ./webpack/requires/view/modules/element-operate.js
 **/